<template>
  <div id="settingsDelivery">

    <TipBox info v-if="isDoorDashShipperActivated">
      <span v-html="$t('tips.doordash.zones')"></span>
    </TipBox>

    <Tabs>

      <TabSection :title="$t('zone.map')" v-if="!isDoorDashShipperActivated">
        <TipBox info :title="$t('tips.polygons.description_2')">
          <ol>
            <li v-html="$t('tips.polygons.ol_1')"></li>
            <li v-html="$t('tips.polygons.ol_2')"></li>
            <li v-html="$t('tips.polygons.ol_3')"></li>
            <li v-html="$t('tips.polygons.ol_4')"></li>
            <li v-html="$t('tips.polygons.ol_5')"></li>
            <li v-html="$t('tips.polygons.ol_6')"></li>
            <li v-html="$t('tips.polygons.ol_7')"></li>
          </ol>
        </TipBox>
        <HereApiPolygonManager :zones="config.delivery.zones" @changed="zoneChanged($event)" @new="newZone($event)">
        </HereApiPolygonManager>
      </TabSection>

      <TabSection :title="$t('settings.delivery_zones')" v-if="!isDoorDashShipperActivated">
        <TipBox info :title="$t('tips.polygons.title')">
          <p v-html="$t('tips.polygons.description')"></p>
        </TipBox>
        <button class="btn btn-primary" @click="() => addZone()"
          v-if="!config.delivery.zonesDisabled">{{ $t("settings.add_zone") }}</button>
        <button class="btn btn-primary" style="margin-left: 10px" @click="disableZonesModal"
          v-if="!config.delivery.zonesDisabled">{{ $t('settings.disable_zones') }}</button>
        <button class="btn btn-primary" @click="enableZones"
          v-if="config.delivery.zonesDisabled">{{ $t('settings.enable_zones') }}</button>
        <div class="zone" v-for="(zone, zoneIndex) of config.delivery.zones" :key="zoneIndex"
          v-if="!config.delivery.zonesDisabled">

          <div class="title">
            {{ $t("settings.zone") }} #{{ zoneIndex + 1 }} <template v-if="zone.name">- {{ zone.name }}</template>
            <div class="flex-grow"></div>
            <button class="btn btn-primary remove" @click="removeZone(zoneIndex)">
              <svgicon src="/icon/close.svg" height="15" width="15"></svgicon>
            </button>
          </div>

          <div class="columns">
            <div class="column">
              <label>{{ $t("name") }}</label>
              <input :id="'txtName' + zoneIndex" type="text" v-model="zone.name">
              <label :for="'selType' + zoneIndex">{{ $t('settings.zone_type') }}</label>
              <select :id="'selType' + zoneIndex" v-model="zone.type">
                <option value="codes">{{ $t('settings.zone_by_code') }}</option>
                <option value="polygon">{{ $t('settings.zone_by_polygon') }}</option>
              </select>
              <label :for="'txtFee' + zoneIndex">{{ $t("settings.delivery_fees") }} ({{ currencySymbol }})</label>
              <input :id="'txtFee' + zoneIndex" type="number" v-model="zone.fees.amount">
              <br>
              <br>
              <div class="subtitle">{{ $t('settings.delay_title') }}</div>
              <label :for="'txtZoneDelay' + zoneIndex">{{ $t("settings.delay") }}</label>
              <input :id="'txtZoneDelay' + zoneIndex" type="number" v-model="zone.averageDelay">
              <br>
              <br>
              <div class="subtitle">{{ $t('settings.minimum_amount') }}</div>
              <TipBox danger no-border>
                <span v-html="$t('tips.minimum_amount')"></span>
              </TipBox>
              <label :for="'txtZoneMinimumPrice' + zoneIndex">{{ $t("settings.minimum_amount") }}
                ({{ currencySymbol }})</label>
              <input :id="'txtZoneMinimumPrice' + zoneIndex" type="number" v-model="zone.fees.minimumPrice">
            </div>
            <div class="column">
              <div v-if="zone.type === 'codes'">
                <label :for="'selZipCodes' + zoneIndex">{{ $t("settings.zone_zip_codes") }}</label>
                <textarea v-model="zone.zipCodes" />
              </div>
              <div v-if="zone.type === 'polygon' && permissions.polygonZoning">
                <label>{{ $t("settings.delivery_polygon") }}</label>
                <textarea v-model="zone.polygons" />
              </div>
            </div>
          </div>

          <!--
          <div :id="'map' + zoneIndex" class="map"></div>
          -->

        </div>
      </TabSection>

      <TabSection :title="$t('settings.general')" v-if="config.delivery" class="general">
        <div class="columns">
          <div class="column">
            <div class="subtitle">
              <span class="flex-grow">{{ $t("settings.delay_title") }}</span>
            </div>
            <div class="group">
              <label>{{ $t("settings.delay") }}</label>
              <input type="number" v-model="config.delivery.general.averageDelay">
            </div>
            <div class="group" v-if="permissions.tipsActivated">
              <div class="subtitle">{{ $t("settings.tip") }}</div>
              <TipBox no-border info>
                <span v-html="$t('tips.tip')"></span>
              </TipBox>
              <label>{{ $t("settings.tip") }}</label>
              <select v-model="config.delivery.general.tipsActivated">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
            <div class="subtitle">
              <span class="flex-grow">{{ $t("settings.service_fee") }}</span>
            </div>
            <TipBox info no-border>
              <span v-html="$t('tips.service_fees')"></span>
            </TipBox>
            <div class="group">
              <label>{{ $t("settings.amount") }} ({{ currencySymbol }})</label>
              <input type="number" v-model="config.delivery.general.serviceFees.amount">
            </div>
          </div>
          <div class="column">
            <div class="subtitle">
              <span class="flex-grow">{{ $t("settings.order_amount") }}</span>
            </div>
            <TipBox danger no-border>
              <span v-html="$t('tips.minimum_amount')"></span>
            </TipBox>
            <div class="columns">
              <div class="column group">
                <label>{{ $t("settings.minimum_amount") }} ({{ currencySymbol }})</label>
                <input type="number" v-model="config.delivery.general.minimumPrice">
              </div>
              <!-- <div class="column group">
                <label>{{$t("settings.maximum_amount")}} ({{currencySymbol}})</label>
                <input type="number" v-model="config.delivery.general.maximumPrice">
              </div> -->
            </div>
            <div class="subtitle">
              <!-- <span class="flex-grow">{{$t("settings.order_clients")}}</span> -->
            </div>
            <div class="columns">
              <!-- <div class="column group">
                <label>{{$t("settings.minimum_clients")}}</label>
                <input type="number" v-model="config.delivery.general.minimumMeals">
              </div> -->
              <!-- <div class="column group">
                <label>{{$t("settings.maximum_clients")}}</label>
                <input type="number" v-model="config.delivery.general.maximumMeals">
              </div> -->
            </div>
            <div class="subtitle" v-if="$store.state.loggedUser.isSuperAdmin" v-show="false">
              <span class="flex-grow">{{ $t("settings.geolocation_service") }}</span>
            </div>
            <div class="columns" v-if="$store.state.loggedUser.isSuperAdmin" v-show="false">
              <div class="column group">
                <label>{{ $t("settings.geolocation_service_enabled") }}</label>
                <select v-model="config.delivery.geocodeService">
                  <option value="google">Google</option>
                  <option value="here">Here API</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </TabSection>

      <TabSection :title="$t('open_hours')" v-if="cascader && config.delivery">
        <TipsOpenHours />
        <div id="editOpenHoursContainerDelivery" class="group">
          <input id="editOpenHoursDelivery" type="checkbox" v-model="config.delivery.editOpenHours">
          <label for="editOpenHoursDelivery">{{ $t("settings.edit_open_hours") }}</label>
        </div>
        <div class="columns" :class="{ openHoursDisabled: !config.delivery.editOpenHours }">
          <div class="column">
            <DayTimeRange :day="cascader.get('delivery.hours.monday').value" dayName="monday" context="delivery"
              errorsKey="config.delivery.hours.monday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('delivery.hours.tuesday').value" dayName="tuesday" context="delivery"
              errorsKey="config.delivery.hours.tuesday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('delivery.hours.wednesday').value" dayName="wednesday" context="delivery"
              errorsKey="config.delivery.hours.wednesday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('delivery.hours.thursday').value" dayName="thursday" context="delivery"
              errorsKey="config.delivery.hours.thursday.hours" :validate="parentValidate"></DayTimeRange>
          </div>
          <div class="column">
            <DayTimeRange :day="cascader.get('delivery.hours.friday').value" dayName="friday" context="delivery"
              errorsKey="config.delivery.hours.friday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('delivery.hours.saturday').value" dayName="saturday" context="delivery"
              errorsKey="config.delivery.hours.saturday.hours" :validate="parentValidate"></DayTimeRange>
            <DayTimeRange :day="cascader.get('delivery.hours.sunday').value" dayName="sunday" context="delivery"
              errorsKey="config.delivery.hours.sunday.hours" :validate="parentValidate"></DayTimeRange>
          </div>
        </div>
      </TabSection>

      <TabSection :title="$t('settings.order_in_advance')" v-if="config.delivery">
        <TipsInAdvance />
        <div id="activateInAdvanceContainerDelivery" class="group">
          <input id="activateInAdvanceDelivery" type="checkbox" v-model="config.delivery.inAdvance.activated">
          <label for="activateInAdvanceDelivery">{{ $t("settings.activate_order_in_advance") }}</label>
        </div>
        <div class="columns" v-if="config.delivery.inAdvance.activated">
          <div class="column">
            <div class="group">
              <label>{{ $t("settings.asap") }}</label>
              <select v-model="config.delivery.inAdvance.ASAP">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
            <div class="group" v-if="$store.state.loggedUser.isSuperAdmin">
              <label>{{ $t('settings.future_dates') }}</label>
              <select v-model="config.delivery.inAdvance.futureDate">
                <option :value="true">{{ $t('yes') }}</option>
                <option :value="false">{{ $t('no') }}</option>
              </select>
            </div>
            <!--
            <div class="group">
              <label>{{$t("settings.outside_open_hours")}}</label>
              <select v-model="config.delivery.inAdvance.outsideHours">
                <option :value="true" selected>{{$t('yes')}}</option>
                <option :value="false">{{$t('no')}}</option>
              </select>
            </div> -->
          </div>
          <div class="column">
            <div class="group">
              <label>{{ $t("settings.interval") }}</label>
              <select v-model="config.delivery.inAdvance.intervalInMinutes">
                <option :value="minute" v-for="minute of [5, 10, 15, 20, 30, 45, 60]">{{ minute }}</option>
              </select>
            </div>
            <div class="group">
              <label>{{ $t("settings.orders_per_interval") }}</label>
              <input type="number" v-model="config.delivery.inAdvance.maxPerInterval">
            </div>
          </div>
        </div>
      </TabSection>

      <TabSection :title="$t('message')" v-if="config.delivery">
        <TipBox info>
          <span v-html="$t('tips.message.delivery')"></span>
        </TipBox>
        <div class="group">
          <LocalizedInput textarea :title="$t('settings.service_message')" :maxSize="200"
            :translate="config.delivery.onEnterMessage.message" />
        </div>
        <div class="group">
          <input id="chkPopupDelivery" type="checkbox" v-model="config.delivery.onEnterMessage.type" true-value="popup"
            :false-value="null">
          <label for="chkPopupDelivery">{{ $t('settings.open_in_window') }}</label>
        </div>
      </TabSection>

      <TabSection :title="$t('notifications')" v-if="config.delivery">
        <TipsNotification />
        <div class="subtitle">
          <span class="flex-grow">{{ $t("settings.on_sale_notification") }}</span>
        </div>
        <TipBox warning v-if="!isSMSactivated" no-border>
          <div v-html="$t('tips.sms_feature.disabled')"></div>
        </TipBox>
        <div class="group" :class="{ locked: !isSMSactivated }">
          <label>{{ $t("settings.sms_notification") }}</label>
          <VueSelect multiple v-model="config.delivery.notifications.onSale.sms" taggable>
            <span slot="no-options">{{ $t("settings.sms_tip") }}</span>
          </VueSelect>
        </div>
        <div class="group">
          <label>{{ $t("settings.email_notification") }}</label>
          <VueSelect multiple v-model="config.delivery.notifications.onSale.emails" taggable>
            <span slot="no-options">{{ $t("settings.email_tip") }}</span>
          </VueSelect>
        </div>
      </TabSection>

      <!--
      <Panel :title="$t('settings.questions')">
        <template v-for="(question, qIndex) of config.delivery.questions">
          <div class="subtitle">
            <span class="flex-grow">{{$t("settings.question") + ' #' + (qIndex + 1)}}</span>
          </div>
          <LocalizedInput :translate="question" />
          <div class="question-options">
            <div class="group">
              <input :id="`del_q_opt_${qIndex}`" type="checkbox" v-model="question.optional">
              <label :for="`del_q_opt_${qIndex}`">{{$t("optional")}}</label>
            </div>
            <button class="btn btn-primary" @click="removeQuestion(qIndex)">X</button>
          </div>
        </template>
        <button class="btn btnAddQuestion btn-primary" @click="addQuestion">
          {{$t('settings.add_question')}}
          <svgicon src="/icon/add.svg" height="15" width="15"></svgicon>
        </button>
      </Panel>
      -->
    </Tabs>

    <div class="footer-actions" v-if="$store.getters.loggedUserHasModifyPermission">
      <button class="btn btn-primary" @click="$emit('save')">{{ $t("save") }}</button>
    </div>

    <Modal name="confirmDisableZones" :title="$t('settings.disable_zones')"
      :actions="[{ name: $t('yes'), action: disableZones }, { name: $t('no'), action: 'close' }]">
      {{ $t('settings.disable_zones_warning') }}
    </Modal>

  </div>
</template>

<script>
  import Vue from 'vue';
  import Cascader from "@/resources/cascader";
  import DayTimeRange from '@/components/tools/DayTimeRange.vue';
  import VueSelect from 'vue-select';
  import LocalizedInput from "@/components/tools/LocalizedInput";
  import HereApiPolygonManager from "@/components/tools/HereApiPolygonManager";
  import TipsNotification from "@/components/tips/TipsNotification.vue";
  import TipsOpenHours from "@/components/tips/TipsOpenHours.vue";
  import TipsInAdvance from "@/components/tips/TipsInAdvance.vue";

  export default {

    name: "SettingsDelivery",

    components: { VueSelect, DayTimeRange, LocalizedInput, HereApiPolygonManager, TipsOpenHours, TipsNotification, TipsInAdvance },

    props: {
      config: Object,
      parentConfig: Object,
      parentValidate: Object,
      permissions: Object,
      isActive: Boolean,
      currencySymbol: {
        type: String,
        default: '$'
      }
    },

    async mounted() {
      this.cascader = new Cascader(this.config, this.parentConfig);
      this.parseZonesToString();
      this.initializeMapPlatform();
      this.updateZoneMaps();
    },

    data() {
      return {
        zones: [],
        cascader: null,
        platform: null
      };
    },

    computed: {
      company() {
        return this.$store.state.contextCompany;
      },
      isSMSactivated() {
        return this.company && this.company.smsActivated;
      },
      isDoorDashShipperActivated() {
        return this.company && this.company.shipper === "doordash";
      }
    },

    methods: {
      addZone: function (polygon) {
        this.config.delivery.zones.push({
          name: "",
          type: polygon ? "polygon" : "codes",
          zipCodes: [],
          polygons:  (polygon ? polygon.toString() : ""),
          averageDelay: "",
          fees: {
            amount: 0,
            minimumPrice: 0,
            taxIncluded: false
          },
        });
        this.updateZoneMaps();
      },
      parseZonesToString() {
        for (let zone of this.config.delivery.zones) {
          if (typeof zone.polygons !== "string") {
            zone.polygons = JSON.stringify(zone.polygons);
          }
        }
      },
      zoneChanged(polygons) {
        for (let i = 0; i < this.config.delivery.zones.length; i++) {
          this.config.delivery.zones[i].polygons = polygons[i];
        }
      },
      newZone(zone) {
        this.addZone(zone);
      },
      removeZone: function (index) {
        this.config.delivery.zones.splice(index, 1);
        this.updateZoneMaps();
      },
      initializeMapPlatform(){
        try {
          this.platform = new H.service.Platform({
            apikey: "YcweJ0n-XSvKeqB81LELcNfh8kCiZce2Uj_LOUqWhdg"
          });
        } catch (e) {
          console.log('error init here api', e)
        }
      },
      updateZoneMaps() {
        if (!this.platform) {
          return;
        }
        let defaultLayers = this.platform.createDefaultLayers();
        setTimeout(() => {
          for (let i = 0; i < this.config.delivery.zones.length; i++) {
            let element = document.getElementById("map" + i);
            if (element && !element.classList.contains("initialized")) {
              let map = new H.Map(
                element,
                defaultLayers.raster.normal.map, {
                center: { lat: 33.8121, lng: -117.9190 },
                zoom: 10,
              }
              );
              let behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map));
              let ui = H.ui.UI.createDefault(map, defaultLayers);
              element.classList.add("initialized");
              window.addEventListener('resize', () => {
                map.getViewPort().resize();
              });
            }
          }
        }, 0);
      },
      _copy(obj) {
        return JSON.parse(JSON.stringify(obj));
      },
      disableZonesModal() {
        this.$modal.show("confirmDisableZones");
      },
      disableZones() {
        this.$modal.show("confirmDisableZones");
        this.config.delivery.zonesDisabled = true;
        this.$forceUpdate();
      },
      enableZones() {
        this.config.delivery.zonesDisabled = false;
        this.$forceUpdate();
      },
      addQuestion() {
        this.config.delivery.questions.push({
          fr: null,
          en: null,
          optional: false
        })
      },
      removeQuestion(index) {
        this.config.delivery.questions.splice(index, 1)
      }
    },

    watch: {
      "config.delivery.editOpenHours": function (edit, old) {
        if (old === undefined) {
          return;
        }
        if (edit) {
          Vue.set(this.config.delivery, "hours", this._copy(this.parentConfig.delivery.hours));
        } else {
          Vue.delete(this.config.delivery, "hours");
        }
        this.$forceUpdate();
      },
      "isActive": function (edit, old) {
        if (edit) {
          window.dispatchEvent(new Event('resize'));
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  #settingsDelivery {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  input,
  select,
  textarea {
    width: 100%;
  }

  .zone {
    margin-top: 30px;
    border-bottom: 1px solid #dbdbdb;

    &:not(:last-child) {
      padding-bottom: 30px;
      border-bottom: 1px dashed #dbdbdb;
    }

    .title {
      font-size: 18px;
      display: flex;
      font-weight: bold;
    }

    label {
      margin-top: 10px;
      margin-bottom: 6px;
    }

    .remove {
      padding: 13px;

      .svgicon {
        fill: #fff;
      }
    }

    textarea {
      height: 150px;
    }
  }

  .map {
    min-height: 200px;
    height: 200px;
    margin-top: 10px;
  }

  .flex {
    display: flex;
  }

  .flex-grow {
    flex-grow: 1;
  }

  .flex-column {
    flex-direction: column;
  }

  .general {
    .subtitle {
      padding-top: 10px;
    }
  }

  #editOpenHoursContainerDelivery,
  #activateInAdvanceContainerDelivery {
    label {
      color: #404040;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }

  .openHoursDisabled {
    opacity: 0.7;
    pointer-events: none;
  }

  input {
    width: 100%;
  }

  .question-options {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  }

  .btnAddQuestion {
    display: flex;
    align-items: center;
    fill: white;

    .svgicon {
      margin-left: 10px;
    }
  }
</style>